import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api, formatApiError } from "@/lib/api";
import Logo from "@/components/Logo";
import { toast } from "sonner";

export default function OlvidePassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(t("forgot.sent"));
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="p-6"><Link to="/"><Logo /></Link></div>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md p-8 bg-[#F9FAFB] border border-gray-200 rounded-2xl">
          <h1 className="text-2xl font-bold text-[#0B0B0B] font-display">{t("forgot.heading")}</h1>
          <p className="mt-2 text-sm text-gray-600">{t("forgot.sub")}</p>

          {sent ? (
            <div className="mt-8 p-4 rounded-md bg-emerald-500/10 border border-emerald-500/40" data-testid="forgot-sent">
              <p className="text-sm text-emerald-800">{t("forgot.sent")}</p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
              <label className="block">
                <span className="text-[11px] font-semibold uppercase tracking-widest text-gray-600">{t("login.email")}</span>
                <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email"
                  className="w-full mt-1 bg-white border border-gray-300 rounded-md px-3 py-2 text-sm text-[#0B0B0B] focus:outline-none focus:border-[#F26A21]" />
              </label>
              <button type="submit" disabled={submitting} data-testid="forgot-submit"
                className="w-full py-3 rounded-md bg-[#F26A21] hover:bg-[#D9541A] text-[#0B0B0B] font-semibold disabled:opacity-60">
                {submitting ? "..." : t("forgot.submit")}
              </button>
            </form>
          )}

          <p className="mt-6 text-center text-sm text-gray-600">
            <Link to="/login" className="text-[#F26A21] hover:text-[#0B0B0B]">← {t("forgot.backLogin")}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
